import { render, staticRenderFns } from "./Discharges.vue?vue&type=template&id=745eb5b6"
import script from "./Discharges.vue?vue&type=script&lang=js"
export * from "./Discharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports